"use client";

import L from "leaflet";
import * as turf from "@turf/turf";

function createIcon(retinaUrl: string, url: string) {
  return L?.Icon ? new L.Icon({ iconRetinaUrl: retinaUrl, iconUrl: url }) : undefined;
}

export const insideIcon = createIcon(
  "/leaflet/images/marker-icon-2x.png",
  "/leaflet/images/marker-icon.png",
);

export const outsideIcon = createIcon(
  "/leaflet/images/marker-icon-yellow-2x.png",
  "/leaflet/images/marker-icon-yellow.png",
);

export function getCentroid(geojson?: GeoJSON.Feature<GeoJSON.Polygon | GeoJSON.MultiPolygon>) {
  if (!geojson) return undefined;
  const centroid = turf.centroid(geojson);
  return turf.flip(centroid).geometry.coordinates;
}

export function isInPolygon(point: number[], geojson?: GeoJSON.Polygon) {
  if (!geojson) return undefined;
  const pt = turf.point(point);
  return turf.booleanPointInPolygon(turf.flip(pt), geojson);
}

export const convertToPolygon = (
  geojson?: GeoJSON.Feature | { type: string; coordinates: any },
) => {
  if (!geojson) return undefined;

  const feature =
    "geometry" in geojson ? geojson : { type: "Feature", geometry: geojson, properties: {} };

  const { type } = feature.geometry;
  if (type !== "Polygon" && type !== "MultiPolygon") {
    const polygons = turf.polygonize(feature as GeoJSON.Feature<GeoJSON.LineString>);
    return polygons.features.length > 0 ? polygons : undefined;
  }

  return geojson;
};
